import request from "@/utils/request";
export function list(data) {
    return request({
        url: '/api/portal/v1/portal/selectColumnNewsInfo',
        method: 'post',
        data
    })
}